<template>
  <div class="page">
    <section>
      <h1>
        죄송합니다. 해당 페이지를 찾을 수 없습니다.
      </h1>
      <p>
        일시적인 현상이거나 삭제된 페이지일 수 있습니다.
        메인화면으로 이동해 주세요.
      </p>
      <div class="button-wrapper">
        <Button
          color="secondary"
          size="large"
          v-on:click="$router.replace('/')"
        >
          메인화면
          <template v-slot:icon>
            <svgCaretRight />
          </template>
        </Button>
      </div>


      <h2>다른 기술들도 체험해 보세요.</h2>
      <!-- {{cards}} -->
      <HomeCards 
        :cards="cards" 
        :scrollName="'images'" 
        class="cards-images"
      />
    </section>
  </div>
</template>

<script>
import Button from '@/components/el/Button'
import svgCaretRight from '@/svg/svgCaretRight'
import HomeCards from '@/components/home/HomeCards'
import {getItemByNames} from '@/tree'

export default {
  data() {
    return {
      cards: getItemByNames([
        'deep_tagging',
        'logo',
        'landmark'
      ])
    }
  },
  components: {
    Button,
    svgCaretRight,
    HomeCards
  }
}
</script>

<style lang="scss" scoped>
section {
  background-color: #f5f5f5;
  padding: 100px 0 130px;
}

h1 {
  font-weight: 700;
  font-size: 36px;
  text-align: center;
  color: var(--gray-900);
  margin: 0 auto 16px;
}

p {
  max-width: 350px;
  margin: 0 auto;
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;
  text-align: center;
  letter-spacing: -0.01em;
  color: var(--gray-700);
}

.button-wrapper {
  margin: 50px 0 0;
  text-align: center;
}

h2 {
  font-weight: 700;
  font-size: 28px;
  text-align: center;
  color: var(--gray-900);
  margin: 100px 0 50px;
}
</style>